import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getFilterFieldValues as getFilterFieldValuesAPI} from '../../../services/entities'
import fixture from '../../../fixtures/reservedForFields.json'

export async function getFilterFieldValues(
  dispatch,
  fieldId,
  search,
  params = {limit: 50, page: 1}
) {
  try {
    dispatch({type: PENDING})
    let response = await getFilterFieldValuesAPI(fieldId, search, params)
    //let response = fixture
    dispatch({type: SUCCESS, payload: {...response, ...params}})
    return response
  } catch (e) {
    console.log(`Get Reservation Configuration Failed: ${fieldId}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
